import React from 'react'
import { Field } from 'react-final-form'
import MenuItem from '@material-ui/core/MenuItem'
import moment from 'moment'
import { Select } from 'components/common/FormInputs'
import 'moment-timezone'

function TimeZone(submitting) {
  return (
    <div className="form-group">
      <Field
        name="timezone"
        component={Select}
        label="TimeZone"
        disabled={submitting.submitting}
        formControlProps={{ fullWidth: true, required: false }}>
        {moment.tz.names().map(timezone => (
          <MenuItem
            component="li"
            button
            key={`dataType_key_${timezone}`}
            value={timezone}>
            {timezone}
          </MenuItem>
        ))}
      </Field>
    </div>
  )
}

export default TimeZone
